export default "__VITE_ASSET__890897ec__"